import React from 'react';
import styled from 'styled-components';
import AnswerBox from './answer-box';
import Feedback from './feedback';
import HighlightParagraph from './highlight-paragraph';

const Wrapper = styled.div`
  display: flex;
  margin-top: 20px;
  padding-bottom: 20px;
`;

const QuestionAndAnswer = styled.div`
  flex: 3;
  margin: 0px 25px 0 0;
`;

const QuestionText = styled.div`
  font-size: 16px;
  font-weight: 700;
  word-break: break-word;
`;

const Owner = styled.p`
  margin-top: 5px;
  font-size: 13px;
  color: #838383;
  font-weight: ${({ theme }) => theme.fontWeight.title};
`;

export const Question = ({ question, term, totalTermFound }) => (
  <Wrapper>
    <QuestionAndAnswer>
      <div>
        <QuestionText>
          <HighlightParagraph term={term} text={question?.question} totalTermFound={totalTermFound} />
        </QuestionText>
        <Owner>
          por {question.owner.name} em {question.createdAt}
        </Owner>
      </div>
      <AnswerBox answer={question.answer} />
    </QuestionAndAnswer>
    <Feedback evaluation={question.evaluation} questionId={question.id} answerId={question.answer.id} />
  </Wrapper>
);
